// INSTISSP-1819 — axios client for calling SRMS directly (SSP reports + dashboards). Auth is the PPA-minted
// bearer token (see srmsToken.js), NOT the PPA login cookie — so no `withCredentials` here: the cookie must
// never travel to SRMS (that is what keeps SRMS stateless / CSRF-free).
import axios from 'axios';
import { url } from '../../../utils/urls'; // the portal's url (spreads iui sharedURLs) — has baseURL, ppa.url and srms
import { getSrmsToken, refresh } from './srmsToken';

const srms = axios.create({ baseURL: url.srms?.url });

// Attach a fresh bearer on every request.
srms.interceptors.request.use(async config => {
    const token = await getSrmsToken();
    config.headers = { ...config.headers, Authorization: `Bearer ${token}` };
    return config;
});

// On a 401 (token expired between mint and use, or clock drift), mint once and retry the same request once.
srms.interceptors.response.use(
    response => response,
    async error => {
        const original = error.config;
        if (error.response?.status === 401 && original && !original._srmsRetried) {
            original._srmsRetried = true;
            try {
                await refresh();
            } catch (e) {
                return Promise.reject(error); // refresh() already handled auth loss (redirect to sign-in)
            }
            return srms(original);
        }
        return Promise.reject(error);
    }
);

export default srms;
